/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BillingCentre from './BillingCentre/index'
import Comments from './Comments/index'
import EffectiveDate from './EffectiveDate/index'
import EmployerName from './EmployerName/index'
import GroupName from './GroupName/index'
import GroupNumber from './GroupNumber/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import InsuranceCarrier from './InsuranceCarrier/index'
import LastDeductiblePaid from './LastDeductiblePaid/index'
import LastVerifiedOn from './LastVerifiedOn/index'
import MemberId from './MemberId/index'
import Policyholder from './Policyholder/index'
import React from 'react'
import RemainingCoverage from './RemainingCoverage/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import UsedCoverage from './UsedCoverage/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/Profile/InsurancePaymentAccount/Content/Content"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--bc-2-Z1Yf8zk': dtColorsNeutral200,'--btlr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-8-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-9-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-10-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--g-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Insurance details"
 color={dtColorsNeutral500}
 weight="medium"
/>
<InsuranceCarrier
  viewPath={`${viewPath}/InsuranceCarrier`}
/>
<GroupNumber
  viewPath={`${viewPath}/GroupNumber`}
/>
<GroupName
  viewPath={`${viewPath}/GroupName`}
/>
<BillingCentre
  viewPath={`${viewPath}/BillingCentre`}
/>
</div>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--g-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Subscription"
 color={dtColorsNeutral500}
 weight="medium"
/>
<Policyholder
  viewPath={`${viewPath}/Policyholder`}
/>
<MemberId
  viewPath={`${viewPath}/MemberId`}
/>
<EmployerName
  viewPath={`${viewPath}/EmployerName`}
/>
<EffectiveDate
  viewPath={`${viewPath}/EffectiveDate`}
/>
<Comments
  viewPath={`${viewPath}/Comments`}
/>
</div>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--g-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical3}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Orthodontic Coverage"
 color={dtColorsNeutral500}
 weight="medium"
/>
<UsedCoverage
  viewPath={`${viewPath}/UsedCoverage`}
/>
<LastDeductiblePaid
  viewPath={`${viewPath}/LastDeductiblePaid`}
/>
<RemainingCoverage
  viewPath={`${viewPath}/RemainingCoverage`}
/>
<LastVerifiedOn
  viewPath={`${viewPath}/LastVerifiedOn`}
/>
</div>
</div>
{children}
</React.Fragment>)
}